module.exports = new __parcel__URL__("orangeBg.67c6b9a3.jpg").toString();